import Vue from "vue";
import VueI18n from 'vue-i18n';
import App from "./App.vue";
import router from "./router";
import store from "./store/index";

import BootstrapVue from "bootstrap-vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from '@fortawesome/free-brands-svg-icons';

import ErrorModal from "@/components/ErrorModal.vue";
import PageHeader from './components/PageHeader'
import PageFooter from './components/PageFooter'

import i18n from "@/languages";

import VueCurrencyFilter from "vue-currency-filter";
import VueCurrencyInput from 'vue-currency-input';
import VueNumeric from 'vue-numeric';
import VueFilterDateFormat from 'vue-filter-date-format';
import Vuelidate from 'vuelidate';
import VueTheMask  from 'vue-the-mask';
import VueFlatPickr from 'vue-flatpickr-component';
import VueInputFacade from 'vue-input-facade';
import VueHtmlToPaper from 'vue-html-to-paper';

import IdleVue from "idle-vue";

import VueHead from 'vue-head';

import {
  AccumulationChartPlugin,
  PieSeries,
  AccumulationLegend,
  AccumulationDataLabel,
  AccumulationTooltip
} from "@syncfusion/ej2-vue-charts";
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';

Vue.use(BootstrapVue);
Vue.use(VueI18n);
Vue.use(VueFilterDateFormat);
Vue.use(VueNumeric);
Vue.use(Vuelidate);
Vue.use(VueTheMask);
Vue.use(VueFlatPickr);
Vue.use(VueInputFacade);

Vue.use((Vue) => {
  // Assign a unique id to each component
  let componentUid = 0;
  Vue.mixin({
    beforeCreate: function() {
      this.componentUid = componentUid.toString();
      componentUid += 1;
    },
  });
  // Generate a component-scoped id
  Vue.prototype.$id = function(id) {
    return "cgnl-" + this.componentUid + "-" + id;
  };
});

library.add(fas);
library.add(fab);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("ErrorModal", ErrorModal);
Vue.component("PageHeader", PageHeader);
Vue.component("PageFooter", PageFooter);

Vue.use(VueCurrencyFilter, {
  symbol: "$",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: false
});

const pluginOptions = { /* see config reference */ }
Vue.use(VueCurrencyInput, pluginOptions)

const paperOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}
Vue.use(VueHtmlToPaper, paperOptions);

Vue.use(AccumulationChartPlugin, {
  accumulationchart: [AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel]
});
Vue.use(ButtonPlugin);
Vue.use(DatePickerPlugin);

Vue.directive('capitalize', {
	update (docElement) {
    const words = docElement.value.split(" ");
    docElement.value = words.map((word) => { 
      if(word) {
        return word[0].toUpperCase() + word.substring(1).toLowerCase(); 
      }
    }).join(" ");
	},
});

Vue.config.productionTip = false;

// Assigning Vue to vm so we can get to it from outside (for in branch controller)
// eslint-disable-next-line
var vm = new Vue({
  data: {
    themeMode: 'light',
  },
  i18n,
  router,
  store,
  validations: {},
  render: h => h(App),
});

// Listen for session inactivity for 15 minutes
Vue.use(IdleVue, {
  eventEmitter: vm,
  store,
  idleTime: 900000,
  startAtIdle: false
});

Vue.use(VueHead);

vm.$mount("#app");